import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=53664a3e&scoped=true"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=js"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=53664a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53664a3e",
  null
  
)

export default component.exports